import React, { createContext } from 'react';
import { ContactUrl } from './ArticleSideNavigation';
import { ViewState } from './CustomerService';

export interface ICustomerServiceContextState {
    view: ViewState;
    urlName: string;
    contact: ContactUrl | null;
    searchTerm: string;
    setView: React.Dispatch<React.SetStateAction<ViewState>>;
    setUrlName: React.Dispatch<React.SetStateAction<string>>;
    setContact: React.Dispatch<React.SetStateAction<ContactUrl | null>>;
    setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

export const defaultCustomerServiceContextState: ICustomerServiceContextState = {
    view: 'main',
    urlName: '',
    contact: null,
    searchTerm: '',
    setView: () => {},
    setUrlName: () => {},
    setContact: () => {},
    setSearchTerm: () => {},
};

export const CustomerServiceContext = createContext<ICustomerServiceContextState>(defaultCustomerServiceContextState);
